export default __webpack_public_path__ + "static/media/Devices.0f729372.png";